import Axios from 'axios';
import CryptoJS from 'crypto-js';
import { store } from '../Redux/Store';
import Type from "../Redux/Type";
import { onCloseRightPanel } from "../Containers/RightPanelAction";

const apiLinkEnterprise = 'https://ilis-sso.vnpt.vn/'
const apiLinkEnterpriseBody = 'https://ilis-cadas-api.vnpt.vn/'
const secretKey = '123456qwertyasdfghzxcvbn!@#$%^';


const URL = {
    getMenuQuyHoach: `QuyHoach/GetMenuQuyHoach`,
    getQuyHoachInfo: `QuyHoach/GetThongTinQuyHoach_v2`,
    getKhaoSatQuyHoach: `QuyHoach/GetThongKeKhaoSatQuyHoach`,
    getPolygonQuyHoach: key => `QuyHoach/GetPolygonQuyHoach?type=${key}`,
    //getQuyHoachLayer: `${apiLink}ilis/wsilis_getDSPolygonQHTheoKhoangCach`,

    loginEnterPrise: `${apiLinkEnterprise}connect/token`,
    ForgetPassWordEnter: `${apiLinkEnterprise}Account/ForgotPassword`,
    getPolygonByDistanceEnter: (X, Y, khoangCach) => `${apiLinkEnterpriseBody}api/ThuaDat/GetThuaDatAndPolygonByDistanceAsync?pointX=${Y}&pointY=${X}&size=${khoangCach}`,
    getPolygonByDistanceNew: (lat, lng, khoangCach) => `${apiLinkEnterpriseBody}api/ThuaDat/GetThuaDatAndPolygonByLatLon?lat=${lat}&lon=${lng}&size=${khoangCach}`,
    getPolygonByToThuaEnter: `${apiLinkEnterpriseBody}api/ThuaDat/GetByDSThuaDat`,
    getDVHCEnterprise: (id) => `${apiLinkEnterpriseBody}api/Authorize/parent/${id}`,
    searchSoToDVHC: (soTo, dvhc) => `${apiLinkEnterpriseBody}api/ToBanDo/SoTo/${soTo}/${dvhc}`,
    searchSoThuaDVHC: (soThua, idBanDo) => `${apiLinkEnterpriseBody}api/DangKyQSDD/SearchViewDangKyDemo?PageSize=1000&CurentPage=1&tukhoa=${soThua}&searchExactly=true&idtobando=${idBanDo}`,
    searchByNameEnter: (name, iddvhc) => `${apiLinkEnterpriseBody}api/DangKyQSDD/SearchViewDangKyDemo?PageSize=1000&CurentPage=1&iddvhc=${iddvhc}&tukhoa=${name}`,
    tokenEnterPrise: '@DataUserEnterprise',
    getInfo: `${apiLinkEnterprise}connect/userinfo`,
    getProvice: `https://ilis-cadas-api.vnpt.vn/api/Authorize/Province`,
    getToaDo: (maXa) => `https://ilis-cadas-api.vnpt.vn/thuadat/publish/communeCenter/${maXa}`,


    urlDownloadIOS: 'itms-services://vienthongtayninh.vn/?action=download-manifest&url=https://dl.dropboxusercontent.com/s/ku8k2i9igdkgrkl/manifest.plist',
    urlDownloadAndroid: 'https://dl.dropboxusercontent.com/s/8ybcoom5zrjyy5l/app-release.apk?dl=0',

};

export default URL;

export const isObject = obj => obj && obj.constructor && obj.constructor === Object;

export function onPostRequest(url, onSuccess, payload) {
    let dataResponse = {
        statusCode: null,
        response: null,
    },
        rawDataHeader = payload,
        token = store.getState().token,
        dataHeader = '';
    if (isObject(payload)) {
        let rawToken = token;
        if (token) {
            token = decodeResponse(token);
            token = JSON.parse(token);
        }
        payload = {
            Username: token.Username || '',
            Token: rawToken || '',
            ...payload,
        };
    }

    dataHeader = encodeResponse(payload);
    Axios.post(encodeURI(url), null, {
        headers: {
            'Content-Type': 'application/json',
            Data: dataHeader,
        }
    })
        .then((res) => {
            dataResponse.statusCode = res.status;
            dataResponse.response = res.data;
            onSuccess(dataResponse);
        })
        .catch((error) => {
            let callBack = () => onPostRequest(url, onSuccess, rawDataHeader);
            handlerError(error, onSuccess, callBack);
        });
}

export function onPostRequestBodyQuyHoach(url, onSuccess, payload) {
    let dataResponse = {
        statusCode: null,
        response: null,
    },
        token = store.getState().token,
        dataHeader = '';
    if (isObject(payload)) {
        let rawToken = token;
        payload = {
            Username: token.Username || '',
            Token: rawToken || '',
            ...payload,
        };
    }
    dataHeader = payload
    dataHeader = encodeResponse(payload);

    Axios.post(encodeURI(url), payload, {
        headers: {
            Data: dataHeader,
        }
    })
        .then((res) => {
            dataResponse.statusCode = res.status;
            dataResponse.response = res.data;
            onSuccess(dataResponse);
        })
        .catch((error) => {
            const status = error.response ? error.response.status : 300;
            const res = null
            onSuccess({ status, res })
        });
}

export function onRequestEnterPrise(url, onSuccess, payload, token) {
    let dataResponse = {
        statusCode: null,
        response: null,
    }
    //    rawDataHeader = payload
    // token = store.getState().TokenEnter;
    if (isObject(payload)) {
        let rawToken = token;
        if (token) {
            token = decodeResponse(token);
            token = JSON.parse(token);
        }
        payload = {
            Username: token.Username || '',
            Token: rawToken || '',
            ...payload,
        };
    }
    Axios.post(encodeURI(url), payload
    )
        .then((res) => {
            dataResponse.statusCode = res.status;
            dataResponse.response = res.data;
            onSuccess(dataResponse);
        })
        .catch((error) => {
            const status = error.response.status;
            const res = null
            onSuccess({ status, res })
            // let callBack = () => onPostRequest(url, onSuccess, rawDataHeader);
            // handlerError(error, onSuccess, callBack);
            // if (error.response && error.response.status === 401) {
            //     localStorage.removeItem('@DataUserEnterprise');
            //     const userInfo = null;
            //     store.dispatch({ type: Type.SET_USER_INFO_ENTER, userInfo });
            //     store.dispatch({ type: Type.SET_TOKEN_ENTER, token: userInfo });
            // }
        });
}

export function onGetRequestEnterPriseBodyProvince(url, onSuccess, token) {
    let dataResponse = {
        statusCode: null,
        response: null,
    },
        rawDataHeader = null
    Axios.get(url,
        {
            headers: {
                'Authorization': 'Bearer ' + token,
            },
        }
    )
        .then((res) => {
            dataResponse.statusCode = res.status;
            dataResponse.response = res.data;
            onSuccess(dataResponse);

        })
        .catch((error) => {
            let callBack = () => onPostRequest(url, onSuccess, rawDataHeader);
            handlerError(error, onSuccess, callBack);
            if (error.response && error.response.status === 401) {
                onSignOut();
            }
        });

}


export function onGetRequestEnterPriseBody(url, onSuccess, payload) {
    let dataResponse = {
        statusCode: null,
        response: null,
    },
        rawDataHeader = payload,
        token = store.getState().TokenEnter;
    if (isObject(payload)) {
        if (token) {
            token = decodeResponse(token);
            token = JSON.parse(token);
        }
    }
    Axios.get(url,
        {
            headers: {
                'Authorization': 'Bearer ' + token,
            },
        }
    )
        .then((res) => {
            dataResponse.statusCode = res.status;
            dataResponse.response = res.data;
            onSuccess(dataResponse);

        })
        .catch((error) => {
            let callBack = () => onPostRequest(url, onSuccess, rawDataHeader);
            handlerError(error, onSuccess, callBack);
            if (error.response && error.response.status === 401) {
                onSignOut()
            }
        });

}

export function onPostRequestEnterPriseBody(url, onSuccess, payload) {
    let dataResponse = {
        statusCode: null,
        response: null,
    },
        rawDataHeader = payload,
        token = store.getState().TokenEnter;
    const config = {
        method: 'post',
        url: url,
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        data: payload
    };
    Axios(config)
        .then((res) => {
            dataResponse.statusCode = res.status;
            dataResponse.response = res.data;
            onSuccess(dataResponse);
        })
        .catch((error) => {
            let callBack = () => onPostRequest(url, onSuccess, rawDataHeader);
            handlerError(error, onSuccess, callBack);
            if (error.response && error.response.status === 401) {
                onSignOut()
            }
        });
}

export function onSignOut() {
    localStorage.removeItem(URL.tokenEnterPrise);
    store.dispatch({ type: Type.SET_TOKEN_ENTER, token: '' })
    store.dispatch({ type: Type.SET_USER_INFO_ENTER, userInfo: '' });
    store.dispatch({ type: Type.SET_STATE_HIEN_TRANG, route: 'showThuaDat', value: false });
    store.dispatch({ type: Type.SET_STATE_QUY_HOACH, route: 'showQuyHoach', value: false });
    store.dispatch({ type: Type.SET_TYPE_MAP, value: 'hybrid' })
    store.dispatch({ type: Type.CLEAR_PATH_DRAWING });
    store.dispatch({ type: Type.SHOW_OFF_DRAWING });
    store.dispatch({ type: Type.SET_STATE_QUY_HOACH, route: 'quyHoachThuaDat', value: [] });
    onCloseRightPanel();
}

export function formatFLetter(inputString) {
    if (inputString) {
        inputString = inputString.split(' ');
        inputString = inputString.map(e => capitalizeFLetter(e));
        inputString = inputString.filter(e => !!e);
        return inputString.join(' ');
    }
    return ""
}

function capitalizeFLetter(inputStr) {
    if (inputStr) {
        inputStr = inputStr.toLowerCase();
        return inputStr.charAt(0).toUpperCase() +
            inputStr.slice(1)
    }
    return ""
}

export const  b64DecodeUnicode = (str) =>{
    return(
        decodeURIComponent(
            Array.prototype.map.call(atob(str), c =>
              '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            ).join(''))
    )
}
 

export const parseJwt = (token) =>{
    return(
        JSON.parse(
        b64DecodeUnicode(
          token.split('.')[1].replace('-', '+').replace('_', '/')
        )
      ))
}
  

export const encodeResponse = (body) => {
    body = JSON.stringify(body);
    let key = CryptoJS.enc.Utf8.parse(secretKey);
    key = CryptoJS.MD5(key);
    key.words.push(key.words[0], key.words[1]);
    let options = { mode: CryptoJS.mode.ECB },
        textWordArray = CryptoJS.enc.Utf8.parse(body),
        encrypted = CryptoJS.TripleDES.encrypt(textWordArray, key, options);
    return encrypted.toString();
};

export const decodeResponse = (encryptedText) => {
    let key = CryptoJS.enc.Utf8.parse(secretKey);
    key = CryptoJS.MD5(key);
    key.words.push(key.words[0], key.words[1]);
    let options = { mode: CryptoJS.mode.ECB },
        decrypted = CryptoJS.TripleDES.decrypt(
            // @ts-ignore
            {
                ciphertext: CryptoJS.enc.Base64.parse(encryptedText),
            },
            key,
            options,
        );
    return decrypted.toString(CryptoJS.enc.Utf8);
};

const handlerError = (error, onSuccess, callBack) => {
    let payload = {
        statusCode: 'Error',
        response: '',
    };
    if (error.response) {
        payload.response = error.response.data;
        payload.statusCode = error.response.status;
        if (error.response.status === 401) {
            onSignOut()
            //onRefreshToken(callBack);
        }
        else
            onSuccess(payload);
    } else if (error.request) {
        payload.response = error.request;
        onSuccess(payload);
    } else {
        // Something happened in setting up the request that triggered an Error
        payload.response = error.message;
        onSuccess(payload);
    }
};

const onRefreshToken = (onSuccess) => {
    let token = store.getState().token;
    if (token) {
        token = decodeResponse(token);
        token = JSON.parse(token);
        let payload = {
            Username: token.Username,
            Password: token.Password,
        },
            strPayload = encodeResponse(payload);
        Axios.post(encodeURI(URL.login), null, {
            headers: {
                'Content-Type': 'application/json',
                Data: strPayload,
            },
        })
            .then((res) => {
                if (res.status === 200 && !!res.data) {
                    localStorage.setItem(URL.token, res.data)
                    store.dispatch({ type: Type.SET_TOKEN, token: res.data });
                    onSuccess();
                }
            })
            .catch((error) => {
                store.getState().signOut();
                if (error.response) {
                    console.log('response', error.response);
                } else if (error.request) {
                    console.log('req', error.request);
                } else {
                    console.log('Message', error.message);
                }
            });
    } else {
        store.getState().signOut();
    }
};


export const formatNumber = number => {
    return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}

export const QD_GiaDat = {
    'QD': '(Số 35/2020/QĐ-UBND)',
    'HIEULUC': '01/09/2020',
}

